import { Component } from '@angular/core';

@Component({
  selector: 'app-e-library-items',
  templateUrl: './e-library-items.component.html',
  styleUrls: ['./e-library-items.component.scss']
})
export class ELibraryItemsComponent {

}
